import React from "react";

const WarehouseOccupancy = () => {
  return (
    <div className="container my-5">
      {/* Title */}
      <div className="text-center mb-4" data-aos="fade-up">
        <h3 className="text-uppercase" >Tamil Nadu Warehousing Corporation Chennai - 32</h3>
        <h5 className="fw-bold mt-2">
          Warehouse Wise Occupancy Position As On 22/11/2025
        </h5>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <table className="table table-bordered text-center align-middle">
          <thead className="table-dark">
            <tr>
              <th>S.No</th>
              <th>Chennai</th>
              <th>Total Capacity</th>
              <th>Occupancy</th>
              <th>Available</th>
              <th>Occupancy %</th>
              <th>Available %</th>
            </tr>
          </thead>
          <tbody className="table-light" >
            <tr>
              <td>1</td>
              <td>Arakkonam</td>
              <td>21400</td>
              <td>16481</td>
              <td>4919</td>
              <td>77.01 %</td>
              <td>22.99 %</td>
            </tr>
            <tr>
              <td>2</td>
              <td>Arni</td>
              <td>12900</td>
              <td>4285</td>
              <td>8615</td>
              <td>33.22 %</td>
              <td>66.78 %</td>
            </tr>
            <tr>
              <td>3</td>
              <td>Kancheepuram</td>
              <td>11400</td>
              <td>10174</td>
              <td>1226</td>
              <td>89.25 %</td>
              <td>10.75 %</td>
            </tr>
            <tr>
              <td>4</td>
              <td>Katpadi</td>
              <td>3400</td>
              <td>3400</td>
              <td>0</td>
              <td>100.00 %</td>
              <td>0.00 %</td>
            </tr>
            <tr>
              <td>5</td>
              <td>Madhuranthakam</td>
              <td>11000</td>
              <td>11000</td>
              <td>0</td>
              <td>100.00 %</td>
              <td>0.00 %</td>
            </tr>
            <tr>
              <td>6</td>
              <td>Polur</td>
              <td>10000</td>
              <td>6858</td>
              <td>3142</td>
              <td>68.58 %</td>
              <td>31.42 %</td>
            </tr>
            <tr>
              <td>7</td>
              <td>Ranipet</td>
              <td>21200</td>
              <td>21200</td>
              <td>0</td>
              <td>100.00 %</td>
              <td>0.00 %</td>
            </tr>
            <tr>
              <td>8</td>
              <td>Tiruvallur</td>
              <td>9400</td>
              <td>9400</td>
              <td>0</td>
              <td>100.00 %</td>
              <td>0.00 %</td>
            </tr>
            <tr>
              <td>9</td>
              <td>Vellore</td>
              <td>12500</td>
              <td>12010</td>
              <td>490</td>
              <td>96.08 %</td>
              <td>3.92 %</td>
            </tr>
          </tbody>
          <tfoot className="fw-bold" style={{ backgroundColor: "#3e4253ff" }} data-aos="zoom-up" data-aos-delay="400">

            <tr >
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} colSpan="2">Total</td>
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} >113200</td>
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} >94808</td>
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} >18392</td>
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} >83.75 %</td>
              <td style={{ backgroundColor: "#3e4253ff", color: "white" }} >16.25 %</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default WarehouseOccupancy;